import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { usePSD2ProxyStatusQuery } from 'hooks/webapi';
import * as R from 'Router/routes';
import TickIcon from 'assets/icons/tick.svg?react';
import CheckIcon from 'assets/icons/check.svg?react';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import { TwButton } from 'components/TwButton/TwButton';
import useClientBankAccountQuery from 'hooks/webapi/client/useClientBankAccountNumber';

const items = ['item_1', 'item_2'] as const;

function UnorderedList({ lines }: { lines: string[] }) {
  const { t } = useTranslation('psd2_verified');
  if (lines.length === 0) return null;
  return (
    <div className="bg-background-accent w-full px-7 py-5">
      <ul className="flex flex-col gap-4">
        {items.map((item) => (
          <li key={t(item)} className="flex gap-4 items-center">
            <CheckIcon
              height={11}
              width={14}
              className="[&_path]:fill-primary"
            />
            <span>{t(item)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

const PSD2Verified = function PSD2VerifiedMemo() {
  const { t } = useTranslation('psd2_verified');
  const { data: statusData, isSuccess } = usePSD2ProxyStatusQuery();
  const navigate = useNavigate();
  const { isLoading } = useClientBankAccountQuery();
  const [lines, setLines] = useState<string[]>([t('item_1')]);

  const handleClick = async () => {
    navigate(R.WAITING);
  };

  useEffect(() => {
    if (isSuccess) {
      if (statusData.typeOfService === 'PDF_PARSER') {
        setLines([]);
      }
    }
  }, [isSuccess]);

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <CardWithIcon
        icon={<TickIcon />}
        heading={t('page_title')}
        className="rounded-none lg:rounded-lg border-none lg:border-1"
      >
        <UnorderedList lines={lines} />
        <div className="mx-auto lg:mx-0 w-full flex justify-center lg:justify-start">
          <TwButton
            onClick={handleClick}
            data-test="psd2-verified"
            disabled={isLoading}
          >
            {t('complete')}
          </TwButton>
        </div>
      </CardWithIcon>
    </>
  );
};

export default PSD2Verified;
